<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <h2>{{ $t("userProfile.changePassword") }}</h2>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.back") }}</b-button>
      </router-link>
    </b-row>

    <div>
      <div>
        <base-row-detail
          :label="$t('userProfile.namePresentation')"
          :value="`${this.model.namePresentation}`"
        ></base-row-detail>
      </div>
      <div class="mt-2">
        <b-form-group
          :label="$t('userProfile.currentPassword')"
          label-for="currentPassword"
        >
          <b-col sm="12" md="4" style="padding-left: 0%">
            <b-form-input
              id="currentPassword"
              type="password"
              :placeholder="$t('userProfile.currentPassword')"
              v-model="model.currentPassword"
            />
          </b-col>
          <span class="text-danger" v-if="modelstate['CurrentPassword']">
            {{ modelstate["CurrentPassword"][0] }}
          </span>
        </b-form-group>
        <b-form-group
          :label="$t('userProfile.newPassword')"
          label-for="newPassword"
        >
          <b-col sm="12" md="4" style="padding-left: 0%">
            <b-form-input
              id="newPassword"
              type="password"
              :placeholder="$t('userProfile.newPassword')"
              v-model="model.newPassword"
            />
          </b-col>
          <span class="text-danger" v-if="modelstate['NewPassword']">
            {{ modelstate["NewPassword"][0] }}
          </span>
        </b-form-group>
        <b-form-group
          :label="$t('userProfile.passwordConfirmation')"
          label-for="passwordConfirmation"
        >
          <b-col sm="12" md="4" style="padding-left: 0%">
            <b-form-input
              id="passwordConfirmation"
              type="password"
              :placeholder="$t('userProfile.passwordConfirmation')"
              v-model="model.passwordConfirmation"
            />
          </b-col>
          <span class="text-danger" v-if="modelstate['PasswordConfirmation']">
            {{ modelstate["PasswordConfirmation"][0] }}
          </span>
        </b-form-group>
      </div>
    </div>

    <b-row>
      <b-col sm="12" md="3">
        <b-button @click="save()"> Salvar </b-button>
      </b-col>
    </b-row>
    <!-- <div>{{modelstate}}</div>  -->
    <!-- <div>{{ model }}</div> -->
  </b-container>
</template>
<script>
import BaseRowDetail from "@/components_rms/base/BaseRowDetail.vue";
export default {
  name: "UserProfileEditPassword",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    BaseRowDetail,
  },
  data() {
    return {
      alert: {
        error: "Verifique os dados informados",
        success: "Senha alterada com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        namePresentation: "",
        currentPassword: "",
        newPassword: "",
        passwordConfirmation: "",
      },
    };
  },
  created() {
    this.loadProfile();
  },
  computed: {
    getUrlBackToList() {
      return `../profile`;
    },
  },
  methods: {
    loadProfile() {
      this.isBusy = true;
      console.log();
      this.$apiScheduler
        .get("/v1/profileDetalied")
        .then((data) => {
          console.log(data.data);
          this.model = data.data;
          this.isBusy = false;
          return model;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.logo(error.response);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    save() {
      console.log(this.model);
      this.submitted = true;

      this.$apiScheduler
        .post("/v1/profile/changePassword", this.model)
        .then((response) => {
          this.model = response.data;
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              // this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>

<style scoped>
.cargo-data-row span {
  color: #c0c1c2;
  line-height: 13px;
  text-transform: none;
  margin-left: 10px;
}
</style>
